import { horizontalEllipsis } from '@ipfabric/frontend-shared-assets/utils/characters';
import { MultiSelect } from '@ipfabric/ui-components/MultiSelect/MultiSelect';
import { Select } from '@ipfabric/ui-components/Select/Select';
import { isSelectTableFilter } from '@ipfabric/utils';
import type { SelectOptionType } from 'components/Select/SelectOption';
import type { FC } from 'react';
import type { ChangeFilterEvent } from './types/ChangeFilterEvent';
import type { SimpleFilterField } from './types/SimpleFilterField';

interface Props {
  filterField: SimpleFilterField;
  options: SelectOptionType<string>[];
  onChangeFilter: (command: ChangeFilterEvent) => void;
  onSubmitFilters: () => void;
  autoFocus?: boolean;
}

export const SimpleSelectFilter: FC<Props> = (props) => {
  const handleChange = async (value: string | string[] | null) => {
    await props.onChangeFilter({
      column: props.filterField.column,
      value,
    });

    props.onSubmitFilters();
  };

  const { filter } = props.filterField;
  const multi = isSelectTableFilter(filter) && filter.multi;

  return multi ? (
    <MultiSelect
      className='max-w-full flex-1'
      clearable
      options={props.options}
      value={
        (props.filterField.value as Exclude<
          typeof props.filterField.value,
          string
        >) ?? []
      }
      onChange={handleChange}
      size='small'
      placeholder={`Choose${horizontalEllipsis}`}
      autoFocus={props.autoFocus}
    />
  ) : (
    <Select.Optional
      className='max-w-full flex-1'
      clearable
      options={props.options}
      value={
        props.filterField.value as Exclude<
          typeof props.filterField.value,
          string[]
        >
      }
      onChange={handleChange}
      size='small'
      placeholder={`Choose${horizontalEllipsis}`}
      autoFocus={props.autoFocus}
    />
  );
};
